module.exports = __webpack_public_path__ + "static/media/fitness-594143_1920.bf7a1788.jpg";